module.exports = __webpack_public_path__ + "static/5-d9f94292f1aaf78961dc4ad1892a30b9.svg";